/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_StartingInputs */

const en_directory_ai_tools_studio_starting = /** @type {(inputs: Directory_Ai_Tools_Studio_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing your lyrics…`)
};

const zh_directory_ai_tools_studio_starting = /** @type {(inputs: Directory_Ai_Tools_Studio_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在写歌词…`)
};

/**
* | output |
* | --- |
* | "Writing your lyrics…" |
*
* @param {Directory_Ai_Tools_Studio_StartingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_starting = /** @type {((inputs?: Directory_Ai_Tools_Studio_StartingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_StartingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_starting(inputs)
	return zh_directory_ai_tools_studio_starting(inputs)
});
export { directory_ai_tools_studio_starting as "directory.ai_tools.studio.starting" }